function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { closest } from '@okee-uikit/react-hooks';
export function getDefaultMousePos() {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0
  };
}
var ALL_DRAG_ELEMENTS = [];
var currentDragElement = null;

if (typeof window !== 'undefined') {
  document.addEventListener('selectstart', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('touchstart', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('dragstart', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('click', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('mousemove', function (e) {
    if (currentDragElement) {
      currentDragElement.handleEvent(e);
    }
  }, false);
  document.addEventListener('mouseup', function (e) {
    if (currentDragElement) {
      currentDragElement.handleEvent(e);
    }
  }, false);
}

export var Drag = function (_Emitter) {
  _inherits(Drag, _Emitter);

  var _super = _createSuper(Drag);

  function Drag() {
    var _this;

    _classCallCheck(this, Drag);

    _this = _super.call(this);
    _this.elem = null;
    _this.dragLimit = 0;
    _this.trigger = '';
    _this.firstFlag = false;
    _this.startMousePos = getDefaultMousePos();
    _this.latestMousePos = getDefaultMousePos();

    _this.draggable = function () {
      return true;
    };

    ALL_DRAG_ELEMENTS.push(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Drag, [{
    key: "dispose",
    value: function dispose() {
      if (this === currentDragElement) {
        currentDragElement = null;
        this.handleDragEnd(this.latestMousePos);
      }

      var ele = this.getElem();
      ele && this.unbindEvent(ele);
      var index = ALL_DRAG_ELEMENTS.indexOf(this);

      if (index >= 0) {
        ALL_DRAG_ELEMENTS.splice(index, 1);
      }
    }
  }, {
    key: "init",
    value: function init(ele) {
      var originELe = this.getElem();

      if (ele !== this.getElem()) {
        originELe && this.unbindEvent(originELe);
        this.bindEvent(ele);
        this.elem = ele;
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$draggable = options.draggable,
          draggable = _options$draggable === void 0 ? true : _options$draggable,
          _options$trigger = options.trigger,
          trigger = _options$trigger === void 0 ? '' : _options$trigger,
          data = options.data,
          _options$dragLimit = options.dragLimit,
          dragLimit = _options$dragLimit === void 0 ? 0 : _options$dragLimit;
      this.draggable = typeof draggable === 'function' ? draggable : function () {
        return draggable;
      };
      this.trigger = trigger;
      this.data = data;
      this.dragLimit = dragLimit;
    }
  }, {
    key: "getElem",
    value: function getElem() {
      return this.elem;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case 'mousedown':
          this.prepareDrag(e);
          break;

        case 'mousemove':
          this.handleDragging(e);
          break;

        case 'mouseup':
          this.handleDragEnd(e);
          break;

        case 'click':
          this.handleClick(e);
          break;
      }
    }
  }, {
    key: "prepareDrag",
    value: function prepareDrag(e) {
      e.stopPropagation();
      var trigger = this.trigger,
          draggable = this.draggable,
          data = this.data;

      if (!draggable() || trigger && !closest(e.target, trigger, this.getElem())) {
        return;
      }

      if (currentDragElement) {
        currentDragElement.handleDragEnd(e);
      }

      currentDragElement = this;
      this.firstFlag = true;
      var shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          metaKey = e.metaKey,
          altKey = e.altKey,
          clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY;
      var startMousePos = this.startMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };
      this.emit('drag-prepare', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        metaKey: metaKey,
        altKey: altKey,
        startMousePos: startMousePos,
        currentMousePos: startMousePos,
        latestMousePos: startMousePos,
        data: data,
        target: this.getDragElem()
      });
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e) {
      this.firstFlag = false;
      var data = this.data,
          startMousePos = this.startMousePos;
      var shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      this.emit('drag-start', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        currentMousePos: startMousePos,
        latestMousePos: startMousePos,
        data: data,
        target: this.getDragElem()
      });
      this.latestMousePos = startMousePos;
    }
  }, {
    key: "handleDragging",
    value: function handleDragging(e) {
      e.stopPropagation();
      var clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY,
          shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      var startMousePos = this.startMousePos,
          latestMousePos = this.latestMousePos,
          data = this.data;
      var currentMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };

      if (this.firstFlag) {
        if (Math.max(Math.abs(startMousePos.clientX - clientX), Math.abs(startMousePos.clientY - clientY)) <= this.dragLimit) {
          return;
        }

        this.handleDragStart(e);
      }

      this.emit('dragging', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        latestMousePos: latestMousePos,
        currentMousePos: currentMousePos,
        data: data,
        target: this.getDragElem()
      });
      this.latestMousePos = currentMousePos;
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd(e) {
      e.stopPropagation();
      currentDragElement = null;

      if (this.firstFlag) {
        this.firstFlag = false;
        return;
      }

      var clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY,
          shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      var startMousePos = this.startMousePos,
          latestMousePos = this.latestMousePos,
          data = this.data;
      var currentMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };
      this.emit('drag-end', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        currentMousePos: currentMousePos,
        latestMousePos: latestMousePos,
        data: data,
        target: this.getDragElem()
      });
      this.latestMousePos = getDefaultMousePos();
      this.startMousePos = getDefaultMousePos();
      this.firstFlag = false;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      currentDragElement = null;
      var clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY,
          shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      var startMousePos = this.startMousePos,
          latestMousePos = this.latestMousePos,
          data = this.data;
      var currentMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };
      this.emit('click', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        currentMousePos: currentMousePos,
        latestMousePos: latestMousePos,
        data: data,
        target: this.getDragElem()
      });
    }
  }, {
    key: "bindEvent",
    value: function bindEvent(ele) {
      ele.addEventListener('mousedown', this, false);
      ele.addEventListener('click', this, false);
    }
  }, {
    key: "unbindEvent",
    value: function unbindEvent(ele) {
      ele.removeEventListener('mousedown', this, false);
      ele.removeEventListener('click', this, false);
    }
  }, {
    key: "getDragElem",
    value: function getDragElem() {
      if (this.elem == null) {
        throw new Error('call init method first');
      }

      return this.elem;
    }
  }]);

  return Drag;
}(Emitter);